export const initMenuHide = function() {
  const indentForBtn = 50;
  const container = document.querySelector('[data-menu-hide="container"]');
  const menu = container.querySelector('[data-menu-hide="list"]');
  const moreButton = container.querySelector('[data-menu-hide="btn"]');
  const dropdown = container.querySelector('[data-menu-hide="dropdown"]');
  const items = Array.from(menu.querySelectorAll('[data-menu-hide="item"]'));
  // Сброс состояний
  items.forEach((item) => menu.appendChild(item));
  if (dropdown) {
    if (dropdown.querySelector('ul')) {
      dropdown.querySelector('ul').innerHTML = '';
    }
  }

  let widthContainer = container.offsetWidth - indentForBtn;

  if (moreButton) {
    widthContainer = container.offsetWidth - moreButton.offsetWidth - indentForBtn;
  }

  // Проверка на переполнение
  if (menu.scrollWidth > widthContainer) {
    dropdown.classList.add('is-visible');
    let isFit = false;

    // Перенос пунктов в выпадающий список
    for (let i = items.length - 1; i >= 0; i--) {
      const item = items[i];
      menu.removeChild(item);
      dropdown.querySelector('ul').prepend(item);

      if (menu.scrollWidth <= widthContainer) {
        isFit = true;
        break;
      }
    }

    if (!isFit) {
      dropdown.classList.add('is-visible');
    }
  }

  // Открытие/закрытие выпадающего списка
  moreButton.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdown.classList.toggle('is-active');
  });

  // Закрытие при клике вне списка
  document.addEventListener('click', () => {
    dropdown?.classList.remove('is-active');
  });
};
